import { PfeBaseActionConfig } from '../pfe-actions.model';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PfeUpdateStateOnBackend = 'PFE_UPDATE_STATE_ON_BACKEND';

export interface PfeUpdateStateOnBackendActionConfig extends PfeBaseActionConfig {
  type: typeof PfeUpdateStateOnBackend;
  pageToReturnTo?: string;
}
